// @flow

import * as React from "react";
import { useSelector } from "react-redux";

import useInvertedNav from "../hooks/useInvertedNav";
import usePageFromStore from "../hooks/usePageFromStore";
import { PrimaryNavPad } from "../components/organisms/PrimaryNav";
import Button from "../components/atoms/Button";
import CustomMeta from "../components/atoms/CustomMeta.js";

import { ReactComponent as Ring } from "../../assets/images/shape-ring-thick-fill.svg";
import { ReactComponent as Diamond } from "../../assets/images/shape-diamond.svg";

const NotFound = (props: any): React.Node => {
    const pageStore = useSelector((state: any): any => state.page);
    const { page } = usePageFromStore();
    const [errorState, setErrorState] = React.useState({
        code: props.httpStatus || "404",
        heading: props.message || "Page not found",
        description: !props.message
            ? "Whoops! We can't find the page you're looking for."
            : "",
    });

    React.useEffect(() => {
        if (pageStore.error) {
            setErrorState({
                code: "500",
                heading: "Something went wrong ",
                description: "Sorry, this page isn’t working.",
            });
        }
    }, [pageStore.error]);

    useInvertedNav();

    // don't show anything whilst handling 301 redirects
    if (page.status === 301) {
        return null;
    }

    return (
        <>
            <CustomMeta title={errorState.heading}>
                <meta
                    name="prerender-status-code"
                    content={errorState.code}
                ></meta>
            </CustomMeta>

            <PrimaryNavPad />

            <div className="not-found page-content page-content--simple">
                <div className="not-found__inner container-fluid">
                    <Ring className="not-found__ring" />
                    <Diamond className="not-found__diamond" />
                    <div className="row center-xs">
                        <div className="col-xs-12 col-md-9">
                            <div className="page-content__inner">
                                <div className="component-builder">
                                    <div className="component-builder__component">
                                        <h1 className="heading-1 center-xs">
                                            <span
                                                style={{
                                                    color: "#666666",
                                                }}
                                            >
                                                {errorState.code}
                                            </span>
                                            <br />
                                            {errorState.heading}
                                        </h1>

                                        <p className="body-18 center-xs">
                                            {errorState.description}
                                        </p>

                                        <Button
                                            className="not-found__cta"
                                            styles={["green"]}
                                            inline={true}
                                            to={"/"}
                                        >
                                            ActivateUTS home
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NotFound;
